export const formatTranslation = (template: string, params?: Record<string, string | number>) => {
  if (!params) return template;
  
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    const value = params[key];
    return value !== undefined ? String(value) : `{{${key}}}`;
  });
}; 